import { useDispatch } from 'react-redux';
import { SparklesIcon } from '@heroicons/react/24/outline';

import { open } from '../../slices/assistantDrawer';

// Sits above the Help tab on the right edge; opens the AI assistant drawer
export function AssistantLauncher() {
  const dispatch = useDispatch();

  return (
    <button
      type={ `button` }
      onClick={ () => dispatch(open(undefined)) }
      className={ `fixed bottom-28 right-0 z-30 flex flex-col items-center rounded-l-md bg-indigo-100 px-1.5 py-2 text-xs font-medium text-gray-800 shadow-sm hover:brightness-95` }
    >
      <SparklesIcon
        className={ `mb-1 h-4 w-4 text-indigo-600` }
        aria-hidden={ `true` }
      />
      <span className={ `tracking-wide [writing-mode:vertical-rl]` }>
        { `Assistant` }
      </span>
    </button>
  );
}
